import React from 'react';
import {Col} from "reactstrap";
import {Icon} from "src/components/Component";
import Tippy from '@tippyjs/react';
import {CalendarIcon} from '@heroicons/react/24/outline';

const Field = ({ description, name, data, itemWidth, type = null }) => {
  return (
    <Col xl={ itemWidth ? itemWidth : 6 }>
      <div>
        <div className="pr-2 pt-1 form-banner">
          <Tippy content={<span>{description}</span>}>
            <span className="font-light">
              { name }
              <Icon
                name="info"
                className="text-primary pl-1 pointer-event"
              />
            </span>
          </Tippy>
        </div>
        <div className="pr-2 pt-1">
        <span className="data-value">
            { type === 'date' && (
              <CalendarIcon className='h-4 w-4 -mt-[3px] inline-block text-violet-800 mr-1' />
            )}
            { data }
        </span>
        </div>
      </div>
    </Col>
  );
}

export default Field;
